import * as React from 'react';
import { DialogTitle } from '@material-ui/core';
import { DialogContent } from '@material-ui/core';
import { DialogActions } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { observer } from 'mobx-react';
import { IObservableObject, IObservableValue, observable } from 'mobx';
import { isValidationErrors, ValidationErrors } from '../../api/restApi';
import { translation } from '../../i18n';
import { Dialog } from '@material-ui/core';
import { QuestionnaireForm } from './QuestionnaireForm';
import { QuestionnaireDto } from './questionnaireTypes';
import { Spinner } from '../../spinner/Spinner';
import { isValidQuestionnaire } from '../../util/validations';
import { updateQuestionnaire } from '../assessment/questionnaireApi';

interface Props {
  onClose: () => void;
  onSave: () => void;
  open: boolean;
  questionnaire: QuestionnaireDto & IObservableObject;
}

@observer
export default class EditQuestionnaireDialog extends React.Component<Props> {

  @observable private validationErrors: ValidationErrors | undefined = undefined;
  private dirtyState: IObservableValue<boolean> = observable.box(false);
  private loading: IObservableValue<boolean> = observable.box(false);

  constructor(props: Props) {
    super(props);
    this.init = this.init.bind(this);
  }

  public render() {
    return (
      <Dialog
        id="editQuestionnaireDialog"
        open={this.props.open}
        onClose={this.props.onClose}
        fullWidth={true}
        maxWidth="md"
        onRendered={this.init}
      >
        <DialogTitle id="form-dialog-title">{translation.t('editQuestionnaireDialog.title')}</DialogTitle>
        {
          this.loading.get() ?
            <Spinner/> :
            <>
              <DialogContent>
                <QuestionnaireForm
                  questionnaire={this.props.questionnaire}
                  existingQuestionnaire={this.props.questionnaire}
                  dirtyState={this.dirtyState}
                  fieldErrors={this.validationErrors ? this.validationErrors.fieldErrors : []}/>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.props.onClose} color="primary">
                  {translation.t('actions.cancel')}
                </Button>
                <Button onClick={() => this.onSaveClicked()} color="primary">
                  {translation.t('actions.save')}
                </Button>
              </DialogActions>
            </>
        }
      </Dialog>)
  }

  private init() {
    this.dirtyState.set(false);
    this.validationErrors = undefined;
  }

  private onSaveClicked() {
    this.validationErrors = isValidQuestionnaire(this.props.questionnaire);
   if (this.validationErrors === undefined || this.validationErrors.fieldErrors.length === 0) {
      this.loading.set(true);
      updateQuestionnaire(this.props.questionnaire).then(
        data => {
          this.loading.set(false);
          if (isValidationErrors(data)) {
            this.validationErrors = data;
          } else {
            this.validationErrors = undefined;
            this.props.onSave();
          }
        }
      )
   }
  }
}
